import { useTranslation } from "react-i18next";

import { SNOOZE_DEPARTMENTS } from "models";

export const useSnoozeDepartmentOptions = () => {
  const { t } = useTranslation();

  return {
    snoozeDepartmentOptions: [
      { key: SNOOZE_DEPARTMENTS.Sales, value: SNOOZE_DEPARTMENTS.Sales, text: t("v8_sales", "Sales") },
      { key: SNOOZE_DEPARTMENTS.CCC, value: SNOOZE_DEPARTMENTS.CCC, text: t("v8_ccc", "CCC (customer communication center)") },
      { key: SNOOZE_DEPARTMENTS.BodyRepair, value: SNOOZE_DEPARTMENTS.BodyRepair, text: t("v8_body_repair", "Body repair") },
      { key: SNOOZE_DEPARTMENTS.External, value: SNOOZE_DEPARTMENTS.External, text: t("v8_external", "External") },
      { key: SNOOZE_DEPARTMENTS.Digital, value: SNOOZE_DEPARTMENTS.Digital, text: t("v8_digital", "Digital (external crm via api)") },
      { key: SNOOZE_DEPARTMENTS.Parts, value: SNOOZE_DEPARTMENTS.Parts, text: t("v8_parts", "Parts") }
    ]
  };
};
